<template>
  <m-single-course-wrapper :course-link="courseLink">
    <template v-slot="{course}">
      <b-container class="scroll-container mt-5">
        <b-row>
          <b-col
              lg="8"
              md="12"
              sm="12"
              class="order-lg-1 order-md-1 order-sm-2 order-2"
          >
            <b-card class="shadow card-detail">
              <b-row class="title-row">
                <h1 class="title">{{ course.title }}</h1>
              </b-row>
              <hr/>
              <b-row class="body-row">
                <b-col class="body-col">
                  <img
                      :src="course.thumbnail"
                      class="e-img"
                      :alt="course.title"
                  />
                  <p class="card-text" v-html="processContent(course.body)"/>
                  <b-row>
                    <b-col>
                      <h5 class="e-title">سرفصل های دوره:</h5>


                      <div v-if="course.lessons" class="accordion" role="tablist">
                        <b-card v-for="(lessons,section_name) in groupLessons(course.lessons)" :key="lessons.id" no-body
                                class="mb-1 border-0">
                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button block v-b-toggle="`accordion-${section_name}`" class="rounded-pill"
                                      variant="info">{{ section_name }}
                            </b-button>
                          </b-card-header>
                          <b-collapse :visible="first_section === section_name" :id="`accordion-${section_name}`"
                                      accordion="my-accordion" role="tabpanel">
                            <b-card-body>

                              <b-row class="text-center bg-primary my-1 text-white py-1 rounded-pill"
                                     v-for="item in lessons" :key="item.id">

                                <b-col>{{ item.title }} ({{ freeTranslation[item.free] }})</b-col>
                                <b-col>
                                  <m-a class="text-white" :href="{name:'SingleLesson',params:{courseSlug:course.slug,slug:item.slug}}">
                                    مشاهده
                                  </m-a>
                                </b-col>

                              </b-row>

                            </b-card-body>
                          </b-collapse>
                        </b-card>

                      </div>


                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col
              lg="4"
              md="12"
              sm="12"
              class="order-lg-2 order-md-1 order-sm-1 order-1 card-info"
          >
            <b-card class="info-card bg-white shadow">
              <b-row class="d-flex flex-column align-items-center info-row">
                <h6 class="info-title font-weight-bolder">اطلاعات دوره</h6>
              </b-row>
              <b-row class="info-row">
                <b-col class="d-flex flex-column align-items-center">
                  <b-icon icon="person"/>
                  <span class="title-2 text-center">مدرس دوره</span>
                  <h6 v-if="course.author" class="font-weight-bolder text-center">
                    {{ `${course.author.name} ${course.author.last_name}` }}</h6>
                </b-col>
                <b-col class="d-flex flex-column align-items-center">
                  <b-icon icon="book"/>
                  <span class="title-2">تعداد دروس</span>
                  <h6 v-if="course.lessons" class="font-weight-bolder">{{ course.lessons.length }}</h6>
                </b-col>
              </b-row>
              <b-row class="info-row">
                <hr class="info-hr"/>
              </b-row>
              <b-row class="info-row">

                <b-col class="d-flex flex-column align-items-center title-2">
                  توضیحات:
                </b-col>

                <b-col class="d-flex flex-column align-items-center title-2">
                  <span v-if="course.course_status" v-html="course.course_status.description"/>
                </b-col>

              </b-row>
              <b-row class="info-row">
                <b-col class="d-flex flex-column align-items-center"
                ><span class="title-2">وضعیت دوره:</span></b-col
                >
                <b-col
                    class="d-flex flex-column align-items-center"
                    v-if="course.course_status && course.course_status.course_status === 1"
                ><span class="font-weight-bolder">کامل شده</span></b-col
                >
                <b-col class="d-flex flex-column align-items-center" v-else
                ><span class="font-weight-bolder">کامل نشده</span></b-col
                >
              </b-row>
              <b-row class="d-flex flex-row justify-content-center info-row">
                <b-button class="info-btn mb-3 shadow" pill>
                  شرکت در دوره
                </b-button>
              </b-row>
            </b-card>
          </b-col>
        </b-row>


        <b-row class="my-5">
          <b-col lg="12">
            <h3 class="text-center my-2">محصولات مرتبط</h3>
          </b-col>
          <m-c301 v-if="course.products" v-for="product in course.products" :product="product" :key="product.id"/>
        </b-row>

      </b-container>


    </template>
  </m-single-course-wrapper>
</template>

<script>
export default {
  name: "SingleCourse1",
  props:{
    courseLink:{
      default:null
    }
  },
  data() {
    return {
      freeTranslation: ['غیررایگان', 'رایگان',],
      first_section: 0
    }
  },
  methods: {
    groupLessons(lessons) {
      let group = {};
      lessons.forEach((lesson) => {
        let section_name = lesson.section_name;
        if (Object.keys(group).indexOf(section_name) === -1) {

          if (Object.keys(group).length === 0) {
            this.first_section = section_name
          }

          group[section_name] = [lesson]
        } else {
          group[section_name].push(lesson)
        }
      })
      return group
    }
  }
};
</script>

<style scoped>
.title {
  text-align: start;
  padding-right: 20px;
  padding-top: 50px;
}

hr {
  background-color: #fff;
  color: #cecece;
  width: 100%;
  display: flex;
  align-self: center;
}

.card-text {
  padding: 20px;
  text-align: right;
  font-size: 15px;
}

.e-title {
  margin-top: 20px;
}


.e-img {
  border-radius: 4px;
  width: 100%;
}

.order-btn :hover {
  background-color: var(--secondary);
}

.title-row {
  display: flex;
  align-items: baseline;
  align-self: center;
  padding: 0 20px 0;
}

.body-row {
  width: 100%;
  align-self: center;
  padding: 20px;
}

.body-col {
  padding: 0;
  margin: 0;
}

.cls-btn {
  background-color: var(--primary);
  border-radius: 4px;
  border: none;
  height: 50px;
  text-align: right;
}

.lessonItem {
  margin-top: 10px;
  padding: 10px;
  background-color: white;
  border-radius: 7px;
  height: 50px;
}

.lesson-item-card {
  border: none;
  padding: 0;
  margin: 0;
}

.lesson-link {
  color: black;
}

.info-hr {
  border: 0;
  border-bottom: 1px dashed;
  background: #999;
}

.info-row {
  padding: 15px 0 0;
}

.info-title {
  text-align: center;
  background-color: var(--primary);
  color: white;
  width: 130px;
  padding: 7px;
  border-radius: 4px;
}

.info-btn {
  background: var(--primary);
  width: 80%;
  color: var(--light);
  border: none;
}

.title-2 {
  font-size: 13px;
}

.product-card {
  margin-top: 20px;
  height: 100%;
}


.scroll-container {
  scroll-behavior: smooth;
}

</style>